import { render, staticRenderFns } from "./CardEndereco.vue?vue&type=template&id=014c1475&scoped=true&"
import script from "./CardEndereco.vue?vue&type=script&lang=js&"
export * from "./CardEndereco.vue?vue&type=script&lang=js&"
import style0 from "./CardEndereco.vue?vue&type=style&index=0&id=014c1475&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014c1475",
  null
  
)

export default component.exports